export default class Vote {
  constructor(vote, deadlineUri, userID, uri = "") {
    this.uri = uri;
    this.deadlineUri = deadlineUri;
    this.memberId = userID;
    this.vote = vote;
    this.memberVote = vote;
  }
}
